<template>
  <div>
    <v-btn
      v-for="(item, i) in items.slice(0, large ? items.length : 3)"
      :key="i"
      :title="item.name"
      fab
      class="ma-2"
      :large="large"
      color="info"
      :href="item.src"
      target="_blank"
    >
      <v-icon
        dark
        v-text="item.icon"
      />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    large: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [
      {
        name: 'Twitter',
        icon: 'mdi-twitter',
        src: 'https://twitter.com/vlad555vlad'
      },
      {
        name: 'Github',
        icon: 'mdi-github-circle',
        src: 'https://github.com/VLD-UKRAINE'
      },
      {
        name: 'Facebook',
        icon: 'mdi-facebook',
        src: 'https://www.facebook.com/profile.php?id=100001561110337'
      },
      {
        name: 'Email',
        icon: 'mdi-email',
        src: 'mailto:vlad555vlad@gmail.com'
      },
      {
        name: 'Phone',
        icon: 'mdi-phone',
        src: 'tel:+380980935351'
      }
    ]
  })
}
</script>
